// KSK119: Special Scheduled Price (KIOSK and MOO / QR). While a period sells an item (or the picked
// choice) below its usual price, the API adds that usual price, struck through next to the
// scheduled price:
// `original_price` (the usual default) for a guest, `original_member_price` for a member.

// The usual price, when the item is on a scheduled price below it; 0 otherwise.
export const scheduleOriginalPrice = (item, isMember = false) => {
  const original = parseFloat(item && (isMember ? item.original_member_price : item.original_price));
  return original > 0 ? original : 0;
};

// "2026-10-27 10:00:00" → "10AM", "17:30:00" → "5:30PM".
const formatScheduleTime = (dateTime) => {
  const [, hh, mm] = String(dateTime || "").match(/(\d{1,2}):(\d{2})/) || [];
  if (hh === undefined) return "";
  const hour = parseInt(hh, 10);
  const suffix = hour < 12 ? "AM" : "PM";
  const h12 = hour % 12 || 12;
  return (mm === "00" ? String(h12) : h12 + ":" + mm) + suffix;
};

// KSK121: "1" → "Every Monday", "1,3,5" → "Every Mon, Wed & Fri"; "" without days.
const formatScheduleDays = (days, t) => {
  const list = String(days || "").split(",").filter(Boolean);
  if (!list.length) return "";
  if (list.length === 1) return t("kiosk.itemCard.everyDays", { days: t("kiosk.itemCard.weekday." + list[0]) });
  const names = list.map((day) => t("kiosk.itemCard.weekdayShort." + day));
  const last = names.pop();
  const joined = t("kiosk.itemCard.dayLast", { list: names.join(t("kiosk.itemCard.daySep")), last });
  return t("kiosk.itemCard.everyDays", { days: joined });
};

// KIOSK: "Special Price | 10AM to 5PM" while the period is on (`price_schedule_start_at` /
// `price_schedule_end_at`, Singapore time), "Special Price | Every Monday, 10AM to 5PM" for a
// weekly one (`price_schedule_days`; no time when `price_schedule_all_day`); just "Special Price"
// when the API sends no period (choices). "" when the item is not on a scheduled price. `t` = this.$t.
export const specialPriceLabel = (item, t, isMember = false) => {
  if (!scheduleOriginalPrice(item, isMember)) return "";
  const days = formatScheduleDays(item.price_schedule_days, t);
  const from = item.price_schedule_all_day ? "" : formatScheduleTime(item.price_schedule_start_at);
  const to = item.price_schedule_all_day ? "" : formatScheduleTime(item.price_schedule_end_at);
  const time = from && to ? t("kiosk.itemCard.timeRange", { from, to }) : "";
  const label = t("kiosk.itemCard.specialPrice");
  const period = days && time ? t("kiosk.itemCard.dayTime", { days, time }) : days || time;
  return period ? label + " | " + period : label;
};
